import { Heading } from 'components/v2/Typography/Heading';
import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;
  overflow: auto;
`;

export const EmptyStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 32px;
  flex: 1;
  justify-content: center;
  position: relative;
  padding: 72px 0;
`;

export const Description = styled(Heading).attrs({ tag: 'div', styledAs: 'h5' })`
  padding: 24px 0;
  text-align: center;
`;
